import React from 'react';
import './DetectionResults.css';

function DetectionResults({ result }) {
  // All labels with score 1.0 are matched (demo_engine lexical mode)
  const matchedLabels = Object.entries(result.all_scores || {})
    .filter(([, score]) => score >= 1.0)
    .map(([label]) => label);

  // Fall back to top_label if scores aren't populated
  const displayLabels = matchedLabels.length > 0 ? matchedLabels : (result.top_label ? [result.top_label] : []);

  return (
    <div className="detection-results">

      <div className="transcript-section">
        <h3>Transcription</h3>
        <p className="transcript-text">"{result.transcript}"</p>
      </div>

      <div className="detection-section">
        <h3>Detection Result</h3>
        {result.triggered ? (
          <div className="detection-triggered">
            <div className="detection-badge success">MATCHED</div>
            <div className="detection-info">
              {displayLabels.length === 1 ? (
                <p className="detected-label">
                  Detected Keyword: <strong>{displayLabels[0]}</strong>
                </p>
              ) : (
                <p className="detected-label">
                  Detected Keywords: {displayLabels.map((label, i) => (
                    <React.Fragment key={label}>
                      <strong>{label}</strong>
                      {i < displayLabels.length - 1 ? ', ' : ''}
                    </React.Fragment>
                  ))}
                </p>
              )}
            </div>
          </div>
        ) : (
          <div className="detection-not-triggered">
            <div className="detection-badge">NO MATCH</div>
            <p>No keywords were detected in the audio.</p>
          </div>
        )}
      </div>

    </div>
  );
}

export default DetectionResults;